import { formatDate } from "../../utils/formatDate";
import { CloseIcon } from "./CloseIcon";
import type { KitRecord } from "../../types/orders";

interface DoctorActionsProps {
  kit: KitRecord;
  onAssign: (kit: KitRecord) => void;
  onReassign: (kit: KitRecord) => void;
  onUnassign?: (kit: KitRecord) => void;
}

export function DoctorActions({ kit, onAssign, onReassign, onUnassign }: Readonly<DoctorActionsProps>) {
  if (!kit.assigned_doctor_id) {
    return (
      <button
        onClick={() => onAssign(kit)}
        className="h-[40px] w-full rounded-xl bg-btn-action text-text-btn text-sm px-4"
      >
        Assign
      </button>
    );
  }

  return (
    <div className="flex flex-col gap-1 items-center">
      {onUnassign ? (
        <div className="flex items-center gap-1">
          <span className="text-sm text-text-primary">{kit.assigned_doctor_name}</span>
          <button
            onClick={() => onUnassign(kit)}
            className="text-text-tertiary hover:text-system-red shrink-0"
            aria-label="Unassign doctor"
          >
            <CloseIcon />
          </button>
        </div>
      ) : (
        <span className="text-xs text-text-tertiary">
          Assigned {formatDate(kit.assigned_at)}
        </span>
      )}
      <button
        onClick={() => onReassign(kit)}
        className="text-sm text-brand-brown underline"
      >
        Reassign
      </button>
    </div>
  );
}
